/** Max size for profile custom avatar uploads (2 MiB). */
export const MAX_PROFILE_AVATAR_BYTES = 2 * 1024 * 1024

export const MAX_PROFILE_AVATAR_MB = 2

/** User-facing copy when a chosen file exceeds the avatar upload limit. */
export const PROFILE_AVATAR_SIZE_ERROR = `Image must be ${MAX_PROFILE_AVATAR_MB} MB or smaller.`

/** Profile photo formats, by MIME type, with the file extension each is stored under. */
export const PROFILE_PHOTO_EXTENSIONS: Readonly<Record<string, string>> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
}

/** For the file input's `accept`, so the picker offers only these formats. */
export const PROFILE_PHOTO_ACCEPT = Object.keys(PROFILE_PHOTO_EXTENSIONS).join(',')

/** User-facing copy when a chosen file is not one of the accepted formats. */
export const PROFILE_PHOTO_TYPE_ERROR = 'Use a JPG, PNG or WebP image.'

/** Why this file can't be a profile photo, or null when it can. */
export function profilePhotoError(file: Pick<File, 'type' | 'size'>): string | null {
  if (!PROFILE_PHOTO_EXTENSIONS[file.type]) return PROFILE_PHOTO_TYPE_ERROR
  if (file.size > MAX_PROFILE_AVATAR_BYTES) return PROFILE_AVATAR_SIZE_ERROR
  return null
}

/** `Profile.displayName` limit (SC-438 D11). The cloud holds the same cap on every save. */
export const MAX_DISPLAY_NAME_LENGTH = 30

/** First and last name limit, as the profile dialog has always enforced. */
export const MAX_PROFILE_NAME_LENGTH = 30
